import React from 'react';
import { t } from '@lingui/core/macro';

import Avatar, { Size } from '@rover/components/src/Avatar';
import TrashSmall from '@rover/icons/svg/trash-small.svg';
import { Box, Button, Flex, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import type { AutomaticRecordResponse } from '@rover/rsdk/src/apiClient/latest/model/automaticRecordResponse';
import type { RatingResponse } from '@rover/rsdk/src/apiClient/latest/model/ratingResponse';
import MessageBubble from '@rover/shared/js/components/MessageBubble';

export type Props = {
  reply: AutomaticRecordResponse | RatingResponse;
  avatarUrl: string;
  onDelete?: () => void;
};
const GrayTrashSmall = (): JSX.Element => {
  const { colors } = useTheme();
  return <TrashSmall color={colors.neutral['700']} width="16px" height="16px" />;
};

const ReviewReply = ({ reply, avatarUrl, onDelete }: Props): JSX.Element => {
  const handleClick = (events?: {
    webEvent?: React.MouseEvent<HTMLElement>;
    rxnEvent?: unknown;
  }): void => {
    // Prevent default behavior on web
    events?.webEvent?.preventDefault?.();
    if (onDelete) onDelete();
  };

  return (
    <Flex aria-label={`${t`Reply from sitter`}, ${reply.response}`}>
      <Flex flexDirection="column" flex="1" pr="3x" data-testid="reviewReplyBody">
        <MessageBubble>
          <Flex flex="1" p="1x" justifyContent="space-between">
            <Text>{reply.response}</Text>
            {onDelete && (
              <Box flexShrink="0">
                <Button
                  alignSelf="flex-start"
                  variant="flat"
                  size="small"
                  icon={GrayTrashSmall}
                  onPress={handleClick}
                  aria-label={`${t`Delete review response`}`}
                  data-testid="reviewReplyButton"
                  p="1x"
                />
              </Box>
            )}
          </Flex>
        </MessageBubble>
      </Flex>
      <Avatar imageUrl={avatarUrl} size={Size.Small} borderRadius={999} />
    </Flex>
  );
};

export default ReviewReply;
